var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ts-page-wrapper ts-homepage",attrs:{"id":"page-top"}},[_c('TopNav'),_c('div',{staticStyle:{"margin":"200px 0"}}),_c('NewActivity'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }